import { MutableRefObject } from 'react';
import { redirect } from '../../providers/MitekProvider/MitekUtils';
import { TNaturalDisaster } from '../../providers/Pushdown/PushdownProvider';
import { clearSessionAndRedirectToDataEntryPage, getAppData } from '../../utils/acquisition-utils';
import SessionStorage from '../../utils/SessionStorage';
import { IMitekDesktopUpdaterProps } from './MitekDesktopUpdater';
import { callAcquisitionBff } from '../../utils/acquisition-api/AcquisitionBff';
import { ICommunicationsResponse } from '../../types/responses/CommunicationsResponse';
import { IApplicationsSearchResponse } from '../../types/responses/ApplicationsSearchResponse';

export const callResendSMS = (props: IMitekDesktopUpdaterProps, showPushdown: (arg: string | TNaturalDisaster, codeOnly?: boolean) => void) => async () => 
    await callAcquisitionBff<ICommunicationsResponse>('communications', {})
        .then((response) => {
            if ((response.data && 'errorMessages' in response.data) || response.status != 200) {
                showPushdown({
                    header: 'There was an error',
                    message: [response.data.ErrorMessage],
                    description: '',
                    color: 'error',
                });
                console.error(response.data.ErrorMessage);
                return false;
            }
            return true;
        })
        .catch((rejection) => {
            console.error(rejection);
            showPushdown(props.apiErrorCode!);
        });

export const handleApplicationApproved = (props: IMitekDesktopUpdaterProps, flowApplicationData: any) => {
            const isCounterOffer = SessionStorage.get('isCounterOffer') === 'true';

            if (flowApplicationData.applicationStatus.riskBasedPricing && !isCounterOffer) {
                redirect(props.riskBasedEsignUrl!);
            }
            if (flowApplicationData.applicationStatus.instantProvisioningInd) {
                const isSignedEsign = SessionStorage.verifyNotEmpty('isEsign') && SessionStorage.getObject('isEsign');
                const isSignedLimitedEsign = SessionStorage.verifyNotEmpty('visitedEsign') && SessionStorage.getObject('visitedEsign');

                SessionStorage.set('rbPricingRequired', flowApplicationData.applicationStatus.isRiskBasedPricingNoticeRequired);
                const redirectUrl = flowApplicationData.applicationStatus.isRiskBasedPricingNoticeRequired && !isSignedEsign && !isSignedLimitedEsign? props.riskBasedEsignUrl : props.mobileWalletUrl;
                redirect(redirectUrl);
            }
            if (flowApplicationData.applicationStatus.limitedeSignRequired) {
                redirect(props.confirmationPageUrl!);
            }
            else {
                if (flowApplicationData.applicationStatus.isSecuredCard) {
                        redirect(props.pendingFundingUrl);
                    } else {
                        redirect(props.confirmationPageUrl!);
                    }
            }
};

export const RefreshCurrentApplication = (
    props: IMitekDesktopUpdaterProps,  
    errorPushdownAPI: (reason: any) => void, 
    intervalRef: MutableRefObject<NodeJS.Timeout>) => async () => {
    await callAcquisitionBff<IApplicationsSearchResponse>('application-search', {})
        .then((response) => {
            if (response.status !== 200) {
                throw response;
            }
            const flowApplicationData = SessionStorage.tryGetObject('flowApplicationData', null);
            flowApplicationData.applicationStatus = response.data.applications[0].applicationStatus.applicationStatus;
            flowApplicationData.letter = response.data.applications[0].letter;
            SessionStorage.setObject('flowApplicationData', flowApplicationData);

            switch (response.data.applications[0].applicationStatus.applicationStatus) {
                case 'HARDDECLINE':
                case 'SOFTDECLINE':
                case 'ERROR':
                    SessionStorage.remove('isCounterOffer');
                    redirect(props.limitedEsignUrl!);
                    break;
                case 'APPROVED':
                    clearInterval(intervalRef.current);
                    handleApplicationApproved(props, flowApplicationData);
                    break;
                case 'PENDING':
                    clearInterval(intervalRef.current);
                    redirect(props.pendingApprovalPageUrl);
                    break;
                default: // null
                    clearSessionAndRedirectToDataEntryPage('lost', props.dataEntryUrl, 'Unsupported application response');
            }
        }).catch((rejection: unknown) => {
            errorPushdownAPI(rejection); 
        });
};